
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 6.667A4.332 4.332 0 0115.333 11 4.332 4.332 0 0111 15.333 4.332 4.332 0 016.667 11 4.332 4.332 0 0111 6.667zm0 2.166A2.173 2.173 0 008.833 11c0 1.191.975 2.166 2.167 2.166A2.173 2.173 0 0013.167 11 2.173 2.173 0 0011 8.833zm-2.167 13a.548.548 0 01-.541-.455l-.401-2.87c-.683-.271-1.268-.64-1.83-1.073l-2.698 1.094a.544.544 0 01-.661-.238L.535 14.542a.534.534 0 01.13-.693l2.286-1.798L2.875 11l.076-1.084L.665 8.151a.534.534 0 01-.13-.694L2.702 3.71c.13-.238.422-.336.66-.238L6.06 4.554c.563-.423 1.148-.79 1.83-1.062l.402-2.87a.548.548 0 01.541-.455h4.334c.27 0 .498.195.541.455l.401 2.87c.683.271 1.268.64 1.831 1.062l2.698-1.083c.238-.098.53 0 .66.238l2.167 3.748c.14.239.076.531-.13.694L19.05 9.916 19.125 11l-.076 1.083 2.286 1.766c.206.162.27.455.13.693l-2.167 3.749c-.13.238-.422.335-.66.238l-2.698-1.083c-.563.422-1.148.79-1.83 1.061l-.402 2.871a.548.548 0 01-.541.455H8.833zm1.355-19.5l-.401 2.828a5.95 5.95 0 00-3.283 1.928l-2.61-1.127-.813 1.409L5.367 9.05a6.012 6.012 0 000 3.9L3.07 14.64l.813 1.408 2.632-1.126a5.898 5.898 0 003.26 1.906l.402 2.838h1.646l.401-2.827a5.978 5.978 0 003.261-1.917l2.633 1.126.812-1.408-2.297-1.68a6.046 6.046 0 000-3.91l2.286-1.68-.812-1.408-2.611 1.127a5.872 5.872 0 00-3.283-1.918l-.4-2.838h-1.625z","fill":"#8E8E8E"}})])
          )
        }
      }
    